import React from 'react'

import './Link.scss'

const Link = ({ className, children, ...rest }) => {
  if (className) {
    className = `Link ${className}`
  } else {
    className = 'Link'
  }

  return (
    <a className={className} {...rest}>
      {children}
    </a>
  )
}

export default Link
